var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "timezone-selector" },
    [
      _c(
        "a-select",
        {
          staticStyle: { width: "140px" },
          attrs: { bordered: false, size: "small" },
          on: { change: _vm.handleTimezoneChange },
          model: {
            value: _vm.currentTimezone,
            callback: function ($$v) {
              _vm.currentTimezone = $$v
            },
            expression: "currentTimezone",
          },
        },
        _vm._l(_vm.timezoneOptions, function (option) {
          return _c(
            "a-select-option",
            { key: option.value, attrs: { value: option.value } },
            [_vm._v(" " + _vm._s(option.label) + " ")]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }